// eslint-disable-next-line import/prefer-default-export
export const sizes = {
  small: {
    height: '24px',
    width: '24px',
  },
  medium: {
    height: '32px',
    width: '32px',
  },
};
